import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedModule } from 'app/shared/shared.module';
import { NgxPaginationModule } from 'ngx-pagination';
import { SendEmailMessageComponent } from './send-email-message/send-email-message.component';
import { EmailMessageDetailsComponent } from './email-message-details/email-message-details.component';
import { EmailMessagesListComponent } from './email-messages-list/email-messages-list.component';
import { EmailMessagesRoutingModule } from './email-messages-routing.module';

@NgModule({
  imports: [
    CommonModule,
    EmailMessagesRoutingModule,
    NgxPaginationModule,
    SharedModule
  ],
  declarations: [
    EmailMessagesListComponent,
    SendEmailMessageComponent,
    EmailMessageDetailsComponent
  ],
  entryComponents: [
    SendEmailMessageComponent,
    EmailMessageDetailsComponent
  ]
})
export class EmailMessagesModule {
}
